var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.778263 12.1743L7.97826 4.97433C8.21226 4.74033 8.59266 4.74033 8.82666 4.97433C9.06066 5.20833 9.06066 5.58873 8.82666 5.82273L2.65146 11.9979H22.2031C22.5343 11.9979 22.8031 12.2667 22.8031 12.5979C22.8031 12.9291 22.5343 13.1979 22.2031 13.1979H2.65146L8.82666 19.3731C9.06066 19.6071 9.06066 19.9875 8.82666 20.2215C8.70906 20.3391 8.55546 20.3967 8.40186 20.3967C8.24826 20.3967 8.09466 20.3379 7.97706 20.2215L0.777063 13.0215C0.543063 12.7875 0.543063 12.4071 0.777063 12.1731L0.778263 12.1743Z",
    fill: "#1B2646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.eb4d88b668f4288cf3a42389e5885dce.svg";
export { ForwardRef as ReactComponent };